<template>
<body id="page-top" class="body-bg">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio certificate-login-section" id="portfolio">
            
            <div class="container">
              <form @submit.prevent="handleSubmit">
                    <div class="login-form">
                    <div v-if="step === 1">
                <p class="h4">WHAT IS YOUR NAME?</p>
                <div class="mb-3 row">
                    <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">LAST NAME</label>
                    <div class="col-sm-10">
                      <input v-model="lastName" type="text" class="form-control" id="exampleFormControlTextarea1" @focus="show" data-layout="normal" required>
                    </div>
               </div>
               <div class="mb-3 row">
                <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">FIRST NAME</label>
                <div class="col-sm-10">
                  <input v-model="firstName" type="text" class="form-control" id="exampleFormControlTextarea1" @focus="show" data-layout="normal" required>
                </div>
            </div>
            </div>

                    <div  v-if="step === 2">
                        <p>Please make sure to type in your correct and active mobile number.</p>     
                <div class="row justify-content-center d-flex align-items-center">
                    <div class="col-5" >
                        <strong class="phone-label">Type your mobile number</strong>
                      </div>
                    <div class="col-7">
                        <div class="input-phone-number col-md-12">
                            <input autocomplete="off" v-model="vuePhone.phone" @focus="show" data-layout="numeric" type="tel" style="width: 70%; font-size: 28px; padding-left: 10px;" id="phone" placeholder="(09)XX-XXX-XXXX" name="phone" v-mask="'(09)##-###-####'" required>
                      </div>
                    </div>
                </div>
                <div class="row justify-content-center d-flex align-items-center">
                    <div class="col-5">
                        <strong class="phone-label">Re-type your mobile number</strong>
                      </div>
                    <div class="col-7">
                        <div class="input-phone-number col-md-12">
                            <input autocomplete="off" v-model="vuePhone.verify" @focus="show" data-layout="numeric" type="tel" style="width: 70%; font-size: 28px; padding-left: 10px;" id="phone" placeholder="(09)XX-XXX-XXXX" name="phone" v-mask="'(09)##-###-####'" required>
                      </div>
                    </div>
                      </div>
                    </div>
                     </div>
                  <div v-if="step === 1" class="col-md-12 member-custom-btn">
                  <router-link to="/member-page"><a style="float:left" type="button" class="btn btn-primary btn-lg">CANCEL</a></router-link>
                  <button @click='previousStep' class="btn btn-primary btn-lg" :disabled="step == 1">PREVIOUS</button>
                  <button type="submit" class="btn btn-primary btn-lg" :disabled="step == 2">NEXT</button>
                  </div>

                  <div v-if="step === 2" class="col-md-12 member-custom-btn">
                  <router-link to="/member-page"><a style="float:left" type="button" class="btn btn-primary btn-lg">CANCEL</a></router-link>
                  <button @click='previousStep' class="btn btn-primary btn-lg" :disabled="step == 1">PREVIOUS</button>
                 <button type="submit" class="btn btn-primary btn-lg">SUBMIT</button>
                  </div>
                     </form>
                  <b-modal ref="my-modal" id="modal-center" content-class="customer-adv-modal" centered title="">
                       <p>{{message}}</p>
                       <button v-if="error === false" @click='logOut'>OK</button>             
                  </b-modal>
            
             
        </div>
                
        </section>
        
             

</body>
</template>

<script>
import axios from 'axios';
export default {
  name: 'PhilLogin',
  data() {
    return {
      firstName: '',
      lastName: '',
      step:1,
      message:'',
      error:true,
      vueTel: {
        phone: "",
        props: {
          preferredCountries: ["PH"],
          placeholder: "Enter your phone",
          mode: "international",
          inputOptions: {
            showDialCode: true
          },
          disabledFormatting: false,
          wrapperClasses: "country-phone-input"
        }
      },
      vuePhone: {
        phone: "",
        verify: "",
        props: {
          clearable: true,
          fetchCountry: true,
          preferredCountries: ["PH"],
          noExample: false,
          translations: {
            countrySelectorLabel: "Country code",
            countrySelectorError: "Error",
            phoneNumberLabel: "Enter your phone",
            example: "Example:"
          }
        }
      },
      visible: false,
        layout: "normal",
        input: null,
        useKbEvents: false,
        preventClickEvent: false,
        assistanceCheckbox:''
    };
    },
  methods: {
     async handleSubmit() {
       if (this.step == 2) {
            var pnumberOnly = this.vuePhone.phone.replace(/[^\d]/g, '');
            if (pnumberOnly.length < 11) {
              this.message="Invalid Mobile Number. Please try again."
              this.showModal()
              this.error = true
            } else if (this.vuePhone.phone != this.vuePhone.verify){
              this.message="Mobile Number did not match. Please try again."
              this.showModal()
              this.error = true
            } else  {

              const response = await axios.post('/api/?action=customer-support', {
                vuePhone: this.vuePhone.phone,
                firstName: this.firstName,
                lastName: this.lastName
              }, 
              );

              console.log(response);
              if (response.data.SuccessFlag == "True"){
                this.message="We have received your request. Our Customer Experience Advocate will reach out to you shortly. You may leave this Smart LOA and wait for our call. Thank you and have a nice day."
                this.error = false
              } else {
                this.message="Submission Failed. Please Try Again."
                this.error = true
              }
              //localStorage.setItem('TokenID', response.data.TokenID)
              
              this.showModal()
              
            }
         }
         if (this.step < 2) {
         this.nextStep()
         }
      },
    logOut() {
        localStorage.removeItem('CertNo');
        this.$router.push('/login');

    },
    previousStep(){
      this.step = this.step-1
    },
    nextStep(){
      this.step = this.step+1
      console.log(this.step);
      //if (this.loginType=="firstCons" && this.step == 3){
       // this.handleSubmit()
      //}
    },
    showModal() {
            this.$refs['my-modal'].show()
          },
        accept() {
          this.hide();
        },
 
        show(e) {
          this.input = e.target;
          this.layout = e.target.dataset.layout;
 
          if (!this.visible)
            this.visible = true
          
        },
 
        hide() {
          this.visible = false;
          console.log(document.querySelector(":focus"));
        }
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
